<template>
  <modal width="45" v-loading="loading" title="Trip Summary " :show-modal="showModal"
    @close-modal="$emit('close-modal')">
    <section>
      <div class="mt-4 rounded p-3">
        <div class="mt-2 border-b-2 pb-1 border-dashed border-gray-300">
          <div class="flex pb-2 items-center">
            <span class="block w-6/12 text-gray-500">Description</span>
            <span class="w-6/12 flex items-center justify-end">{{ totalpackageDiscription }}
              <button @click="isMinimize = !isMinimize" class="text-primary-yellow text-3xl ml-2">
                {{ isMinimize ? "&minus;" : "&plus;" }}
              </button>
            </span>
          </div>
          <div class="flex pb-2" v-if="isMinimize">
            <span class="block w-6/12 text-gray-500">Receiver</span>
            <span class="block w-6/12 text-right">{{
              receieverContactName
              }}
             </span>
          </div>
          <div class="flex pb-2" v-if="isMinimize">
            <span class="block w-6/12 text-gray-500">Sender</span>
            <span class="block w-6/12 text-right">{{
              shipping && shipping.shipperlocation
                ? shipping.shipperlocation.contactName
                : "N/A"
              }}
              ({{
                shipping && shipping.shipperlocation
                  ? shipping.shipperlocation.mobile
                  : "N/A"
              }})</span>
          </div>
        </div>

        <div class="mt-2 border-b-2 pb-1 border-dashed border-gray-300">
          <div class="flex pb-2" v-if="liveTripData.status == 'accepted'">
            <span class="block w-6/12 text-gray-500">Pick-Up Time</span>
            <span class="block w-6/12 text-right" v-if="shouldShowMap">{{
              liveTripData.origin
                ? displayPickupTime()
                : "N/A"
              }}</span>
            <span class="block w-6/12 text-right" v-else>
              {{
                shipping ? momentFormat(shipping.pickUpDays) : "N/A"
              }}
              | {{ shipping.pickUpTime ? shipping.pickUpTime[0] : "N/A" }}
            </span>
          </div>
          <div class="flex pb-2" v-if="liveTripData.status == 'in-transit'">
            <span class="block w-6/12 text-gray-500">Estimated Delivery time</span>
            <span class="block w-6/12 text-right" v-if="shouldShowMap">
              {{ liveTripData.info ? liveTripData.info.duration.text : "---" }}
            </span>
            <span class="block w-6/12 text-right" v-else>
              {{
                shipping.deliveryDays
                  ? momentFormat(shipping.deliveryDays)
                  : "N/A"
              }}
              | {{ shipping.deliveryTime ? shipping.deliveryTime[0] : "N/A" }}
            </span>
          </div>
          <div class="flex pb-2">
            <span class="block w-6/12 text-gray-500">Payment status </span>
            <span class="block w-6/12 text-right">{{
              shipping ? shipping.paymentStatus : ''
              }}</span>
          </div>
        </div>

        <div v-if="shipping.tripId && isLoading" class="flex py-12 flex-wrap mt-3">
          <div class="w-full flex justify-center">
            <span class="loader">
              <img src="@/assets/images/ondemand/loader.svg" /></span>
          </div>
          <p class="w-full text-center pt-4 px-3">
            Fetching Dispatcher Details...<br />
            Might take a while, Please be patient.
          </p>
        </div>
        <div v-else class="flex py-12 flex-wrap mt-3 justify-center">
          No active trip
        </div>
        <div v-if="shouldShowMap && !isLoading" class="mt-2 border-b-2 pb-1 border-dashed border-gray-300">
          <div class="flex pb-2">
            <span class="block w-6/12 text-gray-500">Dispatcher </span>
            <span class="block w-6/12 text-right">{{ liveTripData.driver ? liveTripData.driver.firstname : "--" }}
              {{
                liveTripData.driver
                  ? liveTripData.driver.lastname
                  : "--"
              }}</span>
          </div>
          <div class="flex pb-2">
            <span class="block w-6/12 text-gray-500">Fleet</span>
            <span class="block w-6/12 text-right">{{
              liveTripData.trip && liveTripData.trip.fleet
                ? liveTripData?.trip?.fleet?.vehicleType
                : "N/A"
            }}</span>
          </div>
          <div class="flex pb-2">
            <span class="block w-6/12 text-gray-500">Vehicle Model</span>
            <span class="block w-6/12 text-right">{{
              liveTripData.trip && liveTripData.trip.fleet
                ? liveTripData.trip.fleet.vehicleModel
                : "N/A"
            }}</span>
          </div>
          <div class="flex pb-2">
            <span class="block w-6/12 text-gray-500">Vehicle Number</span>
            <span class="block w-6/12 text-right">{{
              liveTripData.trip && liveTripData.trip.fleet
                ? liveTripData.trip.fleet.vehicleNumber
                : "N/A"
            }}</span>
          </div>
          <div class="flex pb-2">
            <span class="block w-6/12 text-gray-500">Status</span>
            <span class="block w-6/12 text-right text-primary-yellow">{{
              liveTripData.status ? liveTripData.status : "N/A"
              }}</span>
          </div>
        </div>

        <div class="mt-5 flex justify-between">
          <button @click="$emit('close-modal')">Cancel</button>
        </div>
      </div>
    </section>
  </modal>
</template>

<script>
import moment from "moment";
import SocketioService from "../../../../../services/socketio.service";

export default {
  components: {},
  props: {
    center: {
      type: Object,
    },
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  watch: {
    showModal(val) {
      this.socketEventName = this.shipping.tripId;
      if (this.shipping.tripId) {
        console.log(this.shipping)
        if (val && this.shouldShowMap) {
          SocketioService.setupSocketConnection();
          setTimeout(() => {
            this.registerSocket(this.socketEventName, this.shipping.tripId);
          }, 500);

        }
        if (!val && this.shouldShowMap && this.socketEventName) {
          SocketioService.disconnect();
          clearInterval(this.interval);
        }
      }
      this.shouldShowMap && (this.isLoading = true);
      !val && (this.isLoading = false);
    },
    mapCordinate(val) {
      console.log("changed---cordinate", val);
    },
    shipping() {
      this.mapCordinate = this.center;
    },
  },
  mounted() {
    SocketioService.setupSocketConnection();
  },
  methods: {
    displayPickupTime() {
      // Input iOS date string            
      const iosDateString = this.liveTripData?.departure_time;

      // Parse the iOS date string using Moment.js
      const iosDate = moment(iosDateString);

      // Add 900 seconds
      const newIosDate = iosDate.add(this.liveTripData?.info?.duration?.value || 0, "seconds");

      // Format the new date as "YYYY-MM-DD, hh:mm"
      const formattedDate = newIosDate.format("YYYY-MM-DD, hh:mm");
      return formattedDate;
    },
    registerSocket(tripid, shippingId) {
      SocketioService.registerTripId(tripid);

      this.interval = setInterval(() => {
        SocketioService.tripInfo(shippingId).then((data) => {
          console.log("live trip data", data);
          this.liveTripData = data;
          this.isLoading = false;
        });
      }, 1000);
    },
    changeTimeFormat(val) {
      return moment(val).format("DD-MM-YYYY, hh:mm") ?? "";
    },
  },
  computed: {
     receieverContactName() {
      return this.shipping.shipmentReceiever.map((item) => item?.location?.contactName || item?.location?.name || "N/A").join(",")
    },
    contact_Person() {
      return (
        this.shipping?.consigneelocation?.contactPerson ||
        this.shipping?.consigneelocation?.contactName ||
        "N/A"
      );
    },
    totalpackageDiscription() {
      if (!this.shipping?.packagees.length) return "";
      return this.shipping?.packagees
        .map((item) => item?.description)
        .reduce((prev, next) => prev + ", " + next);
    },
    Dispatcher() {
      let handler = this.liveTripData?.trip?.fleet?.vehicleType?.toLowerCase();
      switch (handler) {
        case "bike":
          handler = "Rider of Bike";
          break;
        case "truck":
          handler = "Driver of Truck";
          break;
        case "car":
          handler = "Driver of Car";
          break;
        default:
          break;
      }
      return handler;
    },
    shipping() {
      return this.$store.getters.newCurrentShipping;
    },
    shouldShowMap() {
      return (
        this.shipping?.shippingMethod === "door-to-door" ||
        (this.shipping?.shippingMethod === "terminal-to-door" &&
          !this.shipping?.shippingservice)
      );
    },
  },
  data() {
    return {
      loading: false,
      isMinimize: true,
      mapCordinate: [],
      dispatcher: {},
      socketEventName: "",
      status: "",
      liveTripData: {},
      tripsDetails: {},
      isLoading: false,
      interval: null,
    };
  },
  beforeDestroy() {
    SocketioService.disconnect();
    this.sockets.unsubscribe(this.shipping.id);
    clearInterval(this.interval);
  },
};
</script>

<style lang="scss" scoped>
.loader {
  display: inline-block;
  width: auto;
  height: auto;
  animation: 2s infinite linear rolls;
}

@keyframes rolls {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
